import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CountryContext } from '../contexts/CountryContext';
import { TimezoneContext } from '../contexts/TimezoneContext';
import Button from './Button';
import DesktopCountryPicker from './DesktopCountryPicker';
import DesktopTimezonePicker from './DesktopTimezonePicker';
import Modal from './Modal';
import ModalContent from './ModalContent';
import Typography from './Typography';

const CountryTimezoneModal = ({ close, open }) => {
  const [country, setCountry] = useContext(CountryContext);
  const [timezone, setTimezone] = useContext(TimezoneContext);

  const [activeTimezone, setActiveTimezone] = useState({
    id: timezone,
    name: timezone,
    country: country,
  });

  // Store the original values to be able to dismiss and reset the values to the original.
  // This is because the modal uses context and changes the values in the state
  // as they're changed in the modal.
  const [initTimezoneCountry] = useState({
    id: timezone,
    country: country,
  });

  const handleDismiss = () => {
    setCountry(initTimezoneCountry.country);
    setTimezone(initTimezoneCountry.id);

    close();
  };

  const handleContinue = () => {
    // If the selected country is different from the current country, update the country
    // to match the actively selected timezone's country in Context
    if (activeTimezone.country !== country) {
      setCountry(activeTimezone.country);
    }

    if (activeTimezone.id !== timezone) {
      setTimezone(activeTimezone.id);
    }

    close();
  };

  return (
    <Modal
      dismissable
      isOpen={open}
      modalContent={
        <ModalContent
          buttons={
            <>
              <Button
                fullWidth={false}
                onClick={handleDismiss}
                type="button"
                variant="secondary"
              >
                <FormattedMessage id="Ui.dismiss" />
              </Button>
              <Button
                disabled={Object.keys(activeTimezone).length === 0}
                fullWidth={false}
                onClick={handleContinue}
                type="button"
              >
                <FormattedMessage id="Ui.continue" />
              </Button>
            </>
          }
          header={<FormattedMessage id="CountryTimezoneModal.title" />}
        >
          <div className="mb-5">
            <Typography component="p" variant="subtitle">
              <FormattedMessage id="CountryTimezoneModal.description" />
            </Typography>
          </div>
          <div className="mb-5">
            <DesktopCountryPicker />
          </div>
          <div className="mb-5">
            <DesktopTimezonePicker
              setTimezone={setActiveTimezone}
              timezone={activeTimezone}
            />
          </div>
        </ModalContent>
      }
      onRequestClose={handleDismiss}
    />
  );
};

CountryTimezoneModal.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CountryTimezoneModal;
